import { useEffect, useState } from 'react';
import api from '../../api/axiosConfig';
import { useAuth } from '../../context/AuthContext';

export default function useOrderData(tableId,storeId) {
  const { getAccessToken, isAuthenticated } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {

        //console.log('tableId useOrderData', tableId);
        //console.log('storeId useOrderData', storeId);
        const token = getAccessToken();
        const [productRes] = await Promise.all([
          api.get('/products'),
        ]);
        const filteredProducts = productRes.data?.filter(product => product.store === storeId) || [];
  
        setProducts(filteredProducts);
        //console.log('useOrderData', filteredProducts)
      } catch (err) {
        console.error('Error loading order data', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [tableId, isAuthenticated]);

  return { products,  loading };
}
